import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input, NgModule } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { TranslocoModule } from '@ngneat/transloco';
import { theme } from '@theme/.';

@Component({
  selector: 'apps-banner',
  templateUrl: './apps-banner.component.html',
  styleUrls: ['./apps-banner.component.scss']
})
export class AppsBannerComponent {

  @HostBinding('hidden') isNative = false;

  theme = theme

  constructor() { 
    this.isNative = Capacitor.isNativePlatform();
  }
}

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule
  ],
  declarations: [AppsBannerComponent],
  exports: [AppsBannerComponent]
})
export class AppsBannerComponentModule {}


